import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Instagram, Youtube, Twitch, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { name: 'Twitter', icon: Twitter, url: 'https://twitter.com/blackgamersnet' },
    { name: 'Instagram', icon: Instagram, url: 'https://instagram.com/blackgamersnet' },
    { name: 'YouTube', icon: Youtube, url: 'https://youtube.com/blackgamersnet' },
    { name: 'Twitch', icon: Twitch, url: 'https://twitch.tv/blackgamersnet' },
  ];

  const footerLinks = {
    'Community': [
      { name: 'About Us', path: '/about' },
      { name: 'News & Updates', path: '/news' },
      { name: 'Contact', path: '/contact' },
    ],
    'For Streamers': [
      { name: 'Join Network', path: '/account' },
      { name: 'Streamer Resources', path: '/news' },
      { name: 'Community Guidelines', path: '/about' },
    ],
    'Support': [
      { name: 'Help Center', path: '/contact' },
      { name: 'Report Issues', path: '/contact' },
      { name: 'Privacy Policy', path: '/about' },
    ]
  };

  return (
    <footer className="bg-bgn-black border-t border-bgn-grey/20">
      <div className="max-w-8xl mx-auto px-4 lg:px-8 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-2 space-y-6">
            <div>
              <h3 className="text-3xl font-bold text-bgn-gold mb-4">BGN</h3>
              <p className="text-bgn-grey leading-relaxed max-w-md">
                Amplifying Black voices in gaming and game development. 
                Join our community of passionate gamers, streamers, and creators.
              </p>
            </div>
            
            {/* Newsletter */}
            <div>
              <h4 className="text-white font-semibold mb-3">Stay Connected</h4>
              <div className="flex">
                <input 
                  type="email" 
                  placeholder="Enter your email"
                  className="flex-1 px-4 py-2 bg-bgn-grey/20 border border-bgn-grey/40 rounded-l-full text-white placeholder-bgn-grey focus:outline-none focus:border-bgn-gold"
                />
                <button className="bg-bgn-gold text-bgn-black px-6 py-2 rounded-r-full font-medium hover:bg-white transition-colors duration-200">
                  <Mail size={18} />
                </button>
              </div>
            </div>
          </div>

          {/* Links Sections */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-white font-semibold mb-4">{title}</h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link 
                      to={link.path}
                      className="text-bgn-grey hover:text-white transition-colors duration-200"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="border-t border-bgn-grey/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Copyright */}
            <p className="text-bgn-grey text-sm">
              © {currentYear} Black Gamers Network. All rights reserved.
            </p>

            {/* Social Links */}
            <div className="flex items-center space-x-4">
              <span className="text-bgn-grey text-sm">Follow us:</span>
              {socialLinks.map((social) => {
                const IconComponent = social.icon;
                return (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-bgn-grey hover:text-bgn-gold transition-colors duration-200"
                    aria-label={social.name}
                  >
                    <IconComponent size={20} />
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;